module.exports = __webpack_public_path__ + "static/media/gemDiamonds.0d75e691.png";